import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IPaginationQueryInfo } from 'types/pagination'
import {
  ICreateThreadTopicInput,
  IThreadTopics,
  IThreadTopicsAllUnread,
} from 'types/threads'

type GetThreadTopicsInput = IPaginationQueryInfo & { tenderId?: string }

export const threadTopicsApi = createApi({
  reducerPath: 'threadTopics',
  baseQuery,
  tagTypes: ['ThreadTopics', 'ThreadTopicsAllUnread'],
  endpoints: (builder) => ({
    threadTopics: builder.query<IThreadTopics, GetThreadTopicsInput>({
      query: ({ page, size, tenderId }) => {
        return {
          url: '/thread-topics',
          method: 'get',
          params: {
            page,
            size,
            tenderId,
          },
        }
      },
      providesTags: ['ThreadTopics'],
    }),

    threadTopicsAllUnread: builder.query<
      IThreadTopicsAllUnread,
      { tenderId?: string }
    >({
      query: ({ tenderId }) => {
        return {
          url: '/thread-topics/count-all-unread',
          method: 'get',
          params: {
            tenderId,
          },
        }
      },
      providesTags: ['ThreadTopicsAllUnread'],
    }),

    createThreadTopic: builder.mutation<void, ICreateThreadTopicInput>({
      query: (body) => ({
        url: `/thread-topics`,
        body,
        method: 'post',
      }),
      invalidatesTags: ['ThreadTopics'],
    }),
  }),
})

export const {
  useThreadTopicsQuery,
  useCreateThreadTopicMutation,
  useThreadTopicsAllUnreadQuery,
} = threadTopicsApi
